exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* grid-breakpoints */\n.links span[data-v-4d05c0c8] {\n  display: inline-block;\n  color: white;\n  font-size: 0.8rem;\n}\n.emailBlock[data-v-4d05c0c8], .phoneBlock[data-v-4d05c0c8] {\n  margin-left: 1em;\n}\n.icon[data-v-4d05c0c8] {\n  display: none;\n}\n\n/* Small Screen 544px */\n@media only screen and (min-width: 544px) {\n.toggleButton[data-v-4d05c0c8] {\n    display: none !important;\n}\n.icon[data-v-4d05c0c8] {\n    display: inline-block;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d05c0c8","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navigation/ContactUsLinks.vue
// module id = 644
// module chunks = 3